const detailRoutes = [
  {
    path: 'index',
    name: 'after_sales.show',
    component: require('./show').default,
    meta: {
      title: '售后详情'
    }
  },
  {
    path: 'audits',
    name: 'after_sales.audits',
    component: require('./audits').default,
    meta: {
      title: '售后操作记录'
    }
  }
];

export default [
  {
    path: '/after_sales',
    name: 'after_sales.index',
    component: require('./index').default,
    meta: {
      title: '售后管理',
      navbar: 'el-icon-phone',
      permission: 'after_sales.read'
    }
  },
  {
    path: '/after_sales/new',
    name: 'after_sales.new',
    component: require('./new').default,
    meta: {
      title: '新建售后',
      permission: 'after_sales.create'
    }
  },
  {
    path: '/after_sales/:id',
    component: require('@/layouts/navbar').default,
    props: {
      routes: detailRoutes
    },
    meta: {
      title: '售后详情',
      permission: 'after_sales.read'
    },
    children: detailRoutes
  },
  {
    path: '/after_sales/:id/edit',
    name: 'after_sales.edit',
    component: require('./edit').default,
    meta: {
      title: '修改售后',
      permission: 'after_sales.update'
    }
  }
]
